var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Profile Status Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.72688592,0 C9.55148096,0 9.37633096,0.0589059527 9.23381444,0.177219185 L8.77694573,0.555971928 C8.770572,0.561235864 7.96442309,1.21922789 6.65729927,1.91456879 C5.44501651,2.55952631 3.53595798,3.37518576 1.32503976,3.59852705 L0.716986257,3.65993964 C0.339151755,3.69804051 0.046980136,4.00309814 0.0309183454,4.37608562 L0.00491354168,4.97667568 C6.95096029e-05,5.08947431 -0.103184858,7.77909504 0.941341426,11.0071412 C1.56035774,12.9204567 2.45650367,14.6377532 3.60479422,16.111154 C5.05315981,17.9695742 6.89924593,19.4337004 9.09206276,20.4634266 L9.39672689,20.6065556 C9.50100105,20.655435 9.61368853,20.68 9.72637602,20.68 C9.8390635,20.68 9.95175098,20.655435 10.0560251,20.6065556 L10.3606893,20.4634266 C12.5532512,19.4339511 14.3995922,17.9695742 15.8479578,16.111154 C16.9962484,14.6377532 17.8923943,12.9204567 18.5114106,11.0071412 C19.5544072,7.78310566 19.4526825,5.08997564 19.4478385,4.97692634 L19.4218337,4.37608562 C19.4057719,4.00309814 19.1136003,3.69829117 18.7357658,3.65993964 L18.1277123,3.59852705 C15.917049,3.37518576 14.0079905,2.55952631 12.7957077,1.91456879 C11.4890938,1.21947855 10.6829449,0.561486527 10.6747865,0.554969273 L10.2207222,0.177720512 C10.0779508,0.0594072799 9.90229087,0 9.72688592,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.258008097,4.17608889 C0.184248313,4.10451556 0.147368421,3.99715556 0.147368421,3.92558222 C0.147368421,3.85400889 0.184248313,3.74664889 0.258008097,3.67507556 L0.774326586,3.17406222 C0.921846154,3.03091556 1.14312551,3.03091556 1.29064507,3.17406222 L1.32752497,3.20984889 L3.35591903,5.32126222 C3.42967881,5.39283556 3.54031849,5.39283556 3.61407827,5.32126222 L8.55598381,0.346915556 L8.5928637,0.346915556 C8.74038327,0.203768889 8.96166262,0.203768889 9.10918219,0.346915556 L9.62550067,0.847928889 C9.77302024,0.991075556 9.77302024,1.20579556 9.62550067,1.34894222 L3.72471795,7.28952889 C3.65095816,7.36110222 3.57719838,7.39688889 3.4665587,7.39688889 C3.35591903,7.39688889 3.28215924,7.36110222 3.20839946,7.28952889 L0.331767881,4.28344889 L0.258008097,4.17608889 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Friend-Request",
    transform: "translate(-713.000000, -225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(476.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Status-Copy-3",
    transform: "translate(237.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Verify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify",
    transform: "translate(0.221053, 0.440000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-+-colour/light-green-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    mask: "url(#mask-2)",
    fill: "#91E359"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.326316, -0.440000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.1052632,
    height: 22
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/tick",
    transform: "translate(5.526316, 7.260000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/primary-green",
    mask: "url(#mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.842105, -9.900000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.9684211,
    height: 26.84
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadge);
export default __webpack_public_path__ + "static/media/verifiedBadge.9d5f8a7c05f771bd8a6ebd9e47825568.svg";
export { ForwardRef as ReactComponent };